var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHintIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3670_29988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66982 12.0393C10.4312 12.0393 12.6697 9.80082 12.6697 7.03945C12.6697 4.27808 10.4312 2.03955 7.66982 2.03955C4.90845 2.03955 2.66992 4.27808 2.66992 7.03945C2.66992 9.80082 4.90845 12.0393 7.66982 12.0393Z",
    fill: "#40BAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6732 13.1163H5.6657C5.33476 13.1163 5.06641 12.8479 5.06641 12.517V8.94971H10.2723V12.5172C10.2723 12.8479 10.0041 13.1163 9.6732 13.1163Z",
    fill: "#40BAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77553 14.515H5.56365C5.29229 14.515 5.07227 14.295 5.07227 14.0236C5.07227 13.7522 5.29229 13.5322 5.56365 13.5322H9.77553C10.0469 13.5322 10.2669 13.7522 10.2669 14.0236C10.2669 14.295 10.0469 14.515 9.77553 14.515Z",
    fill: "#40BAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67022 11.5962C7.58157 11.5962 7.50977 11.5244 7.50977 11.4357V9.10918C7.50977 9.02053 7.58157 8.94873 7.67022 8.94873C7.75887 8.94873 7.83067 9.02053 7.83067 9.10918V11.4357C7.83067 11.5244 7.75887 11.5962 7.67022 11.5962Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56451 9.19323C7.50193 9.13065 7.50193 9.02896 7.56451 8.96639L9.20955 7.32135C9.27213 7.25877 9.37381 7.25877 9.43639 7.32135C9.49897 7.38392 9.49897 7.48561 9.43639 7.54819L7.79135 9.19323C7.72877 9.2558 7.62729 9.2558 7.56451 9.19323Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77233 9.19323C7.8349 9.13065 7.8349 9.02896 7.77233 8.96639L6.12729 7.32135C6.06471 7.25877 5.96302 7.25877 5.90045 7.32135C5.83787 7.38392 5.83787 7.48561 5.90045 7.54819L7.54549 9.19323C7.60806 9.2558 7.70975 9.2558 7.77233 9.19323Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3670_29988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12.4752,
    fill: "white",
    transform: "translate(2.66797 2.04004)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint_icon.8d9044b29153ff0d26fb870d49a0b5bc.svg";
export { ForwardRef as ReactComponent };